import React, { useEffect, useState } from 'react';
import { Leaf } from 'lucide-react';

const Hero: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToProducts = () => {
    const element = document.getElementById('products');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero-bg min-h-screen flex items-center justify-center relative">
      {/* Main Content */}
      <div className="container-custom text-center z-10 relative">
        <div className={`transition-all duration-1000 ${isVisible ? 'animate-fade-in-up' : 'opacity-0'}`}> 
          <h1 className="text-6xl md:text-8xl mt-6 font-bold text-primary-800 mb-6">
            <span className="block">SOL NASCENTE</span>
            <span className="block text-4xl md:text-6xl text-primary-600 font-light mt-2">HORTALIÇAS</span>
          </h1>
        </div>
        
        <div className={`transition-all duration-1000 delay-300 ${isVisible ? 'animate-fade-in-up' : 'opacity-0'}`}> 
          <p className="text-xl md:text-2xl text-primary-700 mb-12 max-w-3xl mx-auto leading-relaxed">
            Há mais de 70 anos cultivando qualidade, frescor e tradição familiar.<br />
            <span className="font-semibold text-primary-800">Produzindo qualidade de vida!</span>
          </p>
        </div>

        {/* Action Buttons */}
        <div className={`flex flex-col sm:flex-row gap-6 justify-center mb-16 transition-all duration-1000 delay-500 ${isVisible ? 'animate-fade-in-up' : 'opacity-0'}`}> 
          <a 
            href="https://wa.me/551532415413" 
            target="_blank"
            rel="noopener noreferrer"
            className="bg-primary-600 hover:bg-primary-700 text-white px-8 py-4 rounded-lg font-semibold hover:scale-105 transition-all duration-300 flex items-center justify-center gap-3 shadow-lg border-l-4 border-orange-400"
          >
            <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current text-blue-400">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.109"/>
            </svg>
            <span>Fale Conosco</span>
          </a>
          <button 
            onClick={scrollToProducts}
            className="border-2 border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white px-8 py-4 rounded-lg font-semibold hover:scale-105 transition-all duration-300 flex items-center justify-center gap-3 shadow border-b-4 border-blue-400/70"
          >
            <Leaf size={20} className="text-orange-400" />
            <span>Nossos Produtos</span>
          </button>
        </div>

        {/* Simple Stats */}
        <div className={`grid grid-cols-3 gap-8 md:gap-16 max-w-2xl mx-auto transition-all duration-1000 delay-700 ${isVisible ? 'animate-fade-in-up' : 'opacity-0'}`}>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-primary-700 mb-2">70+</div>
            <div className="text-sm md:text-base text-primary-600">Anos</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-primary-700 mb-2">20+</div>
            <div className="text-sm md:text-base text-primary-600">Regiões</div>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-primary-700 mb-2">100%</div>
            <div className="text-sm md:text-base text-primary-600">Frescos</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
